import script from "./DataSharingConsentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSharingConsentCard.vue?vue&type=script&setup=true&lang=js"

import "./DataSharingConsentCard.vue?vue&type=style&index=0&id=02a3811c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02a3811c"]])

export default __exports__